import { useHistory } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';
import { useCreateRole, usePermissionList } from '../Roles.hooks';
import PermissionList, { RoleSubmitPayload } from './PermissionList';
import Spin from 'Components/Spin/Spin';
import { useTranslation } from 'react-i18next';
import { Notification } from 'Components';

function AddRole() {
	const history = useHistory();
	const { permissionList, loading: permissionsLoading } = usePermissionList();
	const [createRole, { loading: creating }] = useCreateRole();
	const { t } = useTranslation();
	const handleSubmit = async (values: RoleSubmitPayload) => {
		try {
			await createRole(values);
			history.push(getAppRoutes().ROLES);
		} catch (error) {
			Notification.error({
				description: t('errorCodes.genericErrorMessage')
			});
		}
	};

	if (permissionsLoading || creating) return <Spin />;

	return (
		<PermissionList
			mode="add"
			permissionList={permissionList}
			loading={creating}
			onCancel={() => history.push(getAppRoutes().ROLES)}
			onSubmit={handleSubmit}
		/>
	);
}

export default AddRole;